// components/blog/BlogEditor.js
import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Quill from 'quill';

// Registro seguro del módulo imageResize
if (typeof window !== 'undefined' && typeof navigator === 'object') {
  // Hacemos importación dinámica solo si estamos en navegador
  import('quill-image-resize-module-react').then((ImageResize) => {
    Quill.register('modules/imageResize', ImageResize.default || ImageResize);
  });
}

const BlogEditor = ({ control, name = 'content_html', label = 'Contenido' }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image', 'clean'],
    ],
    imageResize: {
      modules: ['Resize', 'DisplaySize'],
    },
  };

  return (
    <div>
      <label className="text-sm font-medium text-gray-700 mb-1 block">{label}</label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <ReactQuill
            theme="snow"
            value={field.value}
            onChange={field.onChange}
            className="bg-white"
            modules={modules}
          />
        )}
      />
    </div>
  );
};

export default BlogEditor;
